import React from 'react';
import { motion } from 'framer-motion';
export function SocialProof() {
  const stats = [{
    value: '+6',
    label: 'Tomos completos'
  }, {
    value: '+3',
    label: 'Bonos exclusivos'
  }, {
    value: '100%',
    label: 'Digital'
  }, {
    value: 'Miles',
    label: 'de años de historia reunidos'
  }];
  return <section className="py-10 border-y border-dark-border bg-dark-card/50" data-id="element-241">
      <div className="max-w-6xl mx-auto px-4" data-id="element-242">
        <div className="text-center mb-10" data-id="element-243">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-white" data-id="element-244">
            Una colección creada para quienes sienten verdadera fascinación por
            el mundo vikingo
          </h2>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center" data-id="element-245">
          {stats.map((stat, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} className="flex flex-col items-center justify-center" data-id="element-246">
              <span className="text-3xl md:text-4xl font-bold text-gold mb-2 font-heading" data-id="element-247">
                {stat.value}
              </span>
              <span className="text-sm md:text-base text-gray-300 font-medium" data-id="element-248">
                {stat.label}
              </span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}